import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { fetchReportingHubReports } from "../services/reporting-hub/fetchReports";

export const useReportingHubData = (
	reportingItems: { key: string }[],
	currentTenantKey: string,
	isMasterTenant: boolean
) => {
	const queries = useQueries({
		queries: reportingItems.map((item) => ({
			queryKey: ["reporting-hub-data", item.key],
			queryFn: async () => {
				return fetchReportingHubReports(
					item.key,
					currentTenantKey,
					isMasterTenant
				);
			},
			enabled: !!currentTenantKey,
			staleTime: 5 * 60 * 1000,
		})),
	});

	const allReports = useMemo(() => {
		return queries
			.filter((q) => Array.isArray(q.data))
			.flatMap((q) => q.data as any[]);
	}, [queries]);

	const isLoading = queries.some((q) => q.isLoading);
	const isError = queries.some((q) => q.isError);

	return {
		allReports,
		isLoading,
		isError,
	};
};
